<div class="display-options">
  <div class="d-flex align-items-center group-of-buttons">
    <div class="pagination-wrapper">
      <app-global-pagination-component
        class="coupons-pagination"
        [page]="page"
        [pageSize]="pageSize"
        [pagination]="pagination"
        [inputPage]="page ?? 1"
        (emitPageChange)="pageChange($event)">
      </app-global-pagination-component>
    </div>
    <div class="position-counter d-none display-small-block">
      <h3 class="positions">
        {{ 'view_translations.positions' | translate }} {{positionsStart}}-{{ ((positionsEnd ?? 0) > (pagination?.total ?? 0)) ? pagination?.total :
        positionsEnd}} {{ 'view_translations.out_of' | translate }} {{pagination?.total}} {{ 'view_translations.in_total' | translate }}
      </h3>
    </div>
    <div class="items-per-page-wrapper" *ngIf="showItemsPerPage">
      <app-sort-dropdown
        id="perPageDropdown"
        class="disp-options-sort"
        (emitChosenValue)="itemsPerPageHandler($event)"
        [disabled]="disabled"
        [sortValues]="valuesForDropdown"
        [onlyNumbers]="onlyNumbers"
        [choosenSortValue]="numberOfItems"
        [sortDropdownClass]="'greyBackground'">
      </app-sort-dropdown>
    </div>
  </div>

  <div class="position-counter display-xs-none">
    <h3 class="positions">
      {{ 'view_translations.positions' | translate }} {{positionsStart}}-{{ ((positionsEnd ?? 0) > (pagination?.total ?? 0)) ? pagination?.total :
      positionsEnd}} {{ 'view_translations.out_of' | translate }} {{pagination?.total}} {{ 'view_translations.in_total' | translate }}
    </h3>
  </div>
</div>
